<template>
    <div class="toggle-alert">
        <div class=" -container">
            <div class="modal-content">
                <div>
                    <div id="alert-modal" class="card bg-orange-gradLight">
                        <button class="btn-close" @click="closeModal()">
                            <img src="/svg/ic_close_orange.svg" alt="close">
                        </button>
                        <div class="card-body">
                            <div class="mensages-container">
                                <img src="/svg/ic_warning.svg" alt="warning" class="message-img">

                                <h1>{{ title }}</h1>

                                <div class="modal-bottom double">
                                    <div class="text-center">
                                        <button :disabled="isLoading" :class="{'disabled': isLoading}" class="btn-bg" @click="confirm()">{{ button }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title:String,
        button: String
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        closeModal(){
            this.togglePageScroll();
            this.$emit('cancel')
        },
        confirm(){
            this.isLoading = true
            this.$emit('confirm')
        },
        togglePageScroll() {
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
    },
    mounted() {
        this.isLoading = false
        this.togglePageScroll();
    },
}
</script>
